import { IconButton, InputAdornment } from "@mui/material";
import React from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const PasswordInput = ({ placeholder, values, setValues }) => {
  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  return (
    <div className="mt-1 relative rounded-md shadow-sm">
      <input
        name="price"
        id="price"
        type={values.showPassword ? "text" : "password"}
        value={values.password}
        onChange={handleChange("password")}
        required
        className="my-5 block w-full p-3 bg-white border 
          border-light rounded-xl text-sm shadow-sm placeholder-gray-400
      focus:outline-none focus:border-off-white focus:ring-0 focus:ring-grey
      disabled:bg-gray-50 disabled:text-gray-500 disabled:border-light 
      disabled:shadow-none"
        placeholder={placeholder}
      />
      <div className="absolute inset-y-0 right-0 pr-5 flex items-center">
        <InputAdornment position="end">
          <IconButton
            aria-label="toggle password visibility"
            onClick={handleClickShowPassword}
            onMouseDown={handleMouseDownPassword}
            edge="end"
          >
            {values.showPassword ? (
              <VisibilityOff className="text-gray-400" />
            ) : (
              <Visibility className="text-gray-400" />
            )}
          </IconButton>
        </InputAdornment>
      </div>
    </div>
  );
};

export default PasswordInput;
